import { Button, DsxFilePdf } from '@dsx/react';
import styles from './FabricCallToAction.module.scss';

interface FabricCallToActionProps {
	onRequestSample?: () => void;
	onSpecSheetDownload?: () => void;
	hasSpecSheet?: boolean;
}

export function FabricCallToAction({
	onRequestSample,
	onSpecSheetDownload,
	hasSpecSheet = false,
}: FabricCallToActionProps) {
	return (
		<div className={styles.fabricCallToAction}>
			<Button
				variant="primary"
				onClick={onRequestSample}
				className={styles.ctaButton}
			>
				Request Sample
			</Button>

			{hasSpecSheet && (
				<Button
					variant="subtle"
					onClick={onSpecSheetDownload}
					className={styles.ctaButton}
					icon={DsxFilePdf}
				>
					Spec Sheet
				</Button>
			)}
		</div>
	);
}
